import "core-js/modules/es.function.name.js";
/* eslint-disable react/prop-types */
import React from 'react';
import { Field } from 'redux-form';
import ErrorBlock from "./ErrorBlock";
import { _AcceptedWrapper, _QuestionField, _RejectedReasonWrapper } from "../style";
var RenderQuestion = function RenderQuestion(_ref) {
  var acceptedMetaText = _ref.acceptedMetaText,
    labelText = _ref.labelText,
    component = _ref.component,
    options = _ref.options,
    name = _ref.name,
    disabled = _ref.disabled,
    maxLength = _ref.maxLength,
    rejectionMetaText = _ref.rejectionMetaText,
    rejectionReason = _ref.rejectionReason,
    subLabel = _ref.subLabel,
    errors = _ref.errors;
  return /*#__PURE__*/React.createElement(_QuestionField, null, /*#__PURE__*/React.createElement(Field, {
    disabled: disabled,
    labelText: labelText,
    component: component,
    options: options,
    name: name,
    maxLength: maxLength,
    required: !disabled,
    subLabel: subLabel
  }), /*#__PURE__*/React.createElement(ErrorBlock, {
    errors: errors
  }), rejectionReason && /*#__PURE__*/React.createElement(_RejectedReasonWrapper, null, /*#__PURE__*/React.createElement("span", null, rejectionMetaText), /*#__PURE__*/React.createElement("span", null, rejectionReason)), acceptedMetaText && /*#__PURE__*/React.createElement(_AcceptedWrapper, null, /*#__PURE__*/React.createElement("span", null, acceptedMetaText)));
};
export default RenderQuestion;